export default "__VITE_ASSET__D8iw4_Gt__"